import { AuthActions } from "../LoginRedux/Action";
import { newOrderActions } from "./action";

const initialState = {
  newOrderDetailsSuccess: null,
  newOrderDetailsError: null,
  confirmMissingMedSuccess: null,
  confirmMissingMedError: null,
  isLoading: true,
};

export const newOrderDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case newOrderActions.FETCH_ORDER_DATA_SUCCESS:
      return {
        ...state,
        newOrderDetailsSuccess: action.payload,
        newOrderDetailsError: null,
        isLoading: false,
      };

    case newOrderActions.FETCH_ORDER_DATA_FAILURE:
      return {
        ...state,
        newOrderDetailsSuccess: null,
        newOrderDetailsError: action.payload,
        isLoading: false,
      };
    case newOrderActions.CONFIRM_MISSINGMED_DATA_SUCCESS:
      return {
        ...state,
        confirmMissingMedSuccess: action.payload,
        confirmMissingMedError: null,
        isLoading: false,
      };

    case newOrderActions.CONFIRM_MISSINGMED_DATA_FAILURE:
      return {
        ...state,
        confirmMissingMedSuccess: null,
        confirmMissingMedError: action.payload,
        isLoading: false,
      };

    default:
      return state;
  }
};
